import { css } from 'styled-components';

// 화면 크기를 기준으로 스타일을 정의하는 sizes 객체
const sizes = {
  padMin: 560,  // mobile: <= 768
  padMax: 1199,  // pad: <= 1439
  tabletMin: 1200,  // tablet: 1440 ~ 1919
  tabletMax: 1919,
  desktopMin: 1920, // desktop: >= 1920
};

export const media = {
  mobile: (args: TemplateStringsArray, ...values: any[]) => css`
    @media (max-width: ${sizes.padMin}px) {
      ${css(args, ...values)}
    }
  `,
  pad: (args: TemplateStringsArray, ...values: any[]) => css`
    @media (min-width: ${sizes.padMin}px) and (max-width: ${sizes.padMax}px) {
      ${css(args, ...values)}
    }
  `,
  tablet: (args: TemplateStringsArray, ...values: any[]) => css`
    @media (min-width: ${sizes.tabletMin}px) and (max-width: ${sizes.tabletMax}px) {
      ${css(args, ...values)}
    }
  `,
  desktop: (args: TemplateStringsArray, ...values: any[]) => css`
    @media (min-width: ${sizes.desktopMin}px) {
      ${css(args, ...values)}
    }
  `,
};